export default __webpack_public_path__ + "static/media/shubham.584b2799.jpg";